<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Title Page">
<div class="ipadfp"><span aria-label="page iii" id="page_iii" role="doc-pagebreak"><img alt="Out of Range, by Heidi Lang, Margaret K. McElderry Books" class="imagefp" src="e9781665903363/images/title.jpg"/></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?075464a5